var _path, _circle, _circle2, _circle3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanninStepBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1338,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10h1336",
    stroke: "url(#paint0_linear_5680_11315)",
    strokeWidth: 5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "url(#paint1_linear_5680_11315)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 403,
    cy: 10,
    r: 10,
    fill: "url(#paint2_linear_5680_11315)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 795,
    cy: 10,
    r: 10,
    fill: "url(#paint3_linear_5680_11315)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5680_11315",
    x1: 2,
    y1: 10,
    x2: 1338,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6C0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F68084"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5680_11315",
    x1: 0,
    y1: 10,
    x2: 20,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6C0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F68084"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5680_11315",
    x1: 393,
    y1: 10,
    x2: 413,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6C0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F68084"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5680_11315",
    x1: 785,
    y1: 10,
    x2: 805,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6C0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F68084"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanninStepBar);
export default __webpack_public_path__ + "static/media/plannin-step-bar.7e7e4e67cfe69e51a4004e5b30310726.svg";
export { ForwardRef as ReactComponent };